import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, UntypedFormGroup } from '@angular/forms';
import { first } from 'rxjs/operators';
import { ReportService } from '@app/_components/report';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';

@Component({
    selector: 'app-short-term-rental-select',
    providers: [MessageService, ConfirmationService],
    template: `
<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-autoComplete [(ngModel)]="shortTermRental" [field]="printOptions" [suggestions]="filteredResults" (completeMethod)="filter($event)" (onSelect)="onSelect($event)" [minLength]="1" [dropdown] = "true" >
	<ng-template let-shortTermRental pTemplate = "item" >
		{{ shortTermRental.propertyCode}}
	</ng-template>
</p-autoComplete>
`,
    standalone: false
})

export class ShortTermRentalSelectComponent implements OnInit, OnChanges
{
	// forms
	propertySelectForm: UntypedFormGroup;
	formLoading = false;
	shortTermRentals = [];
	shortTermRental: any;
	filteredResults: any;
	@Output() doSelectShortTermRental = new EventEmitter<any>();
	@Input() shortTermRentalId: number;
	@Input() reset: boolean;

	constructor(
		private reportService: ReportService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,)
	{ }
	ngOnChanges(changes: SimpleChanges): void
	{
		console.log('reset! ' + changes.reset);
		if (this.reset)
		{

			this.propertySelectForm.reset();
		}
	}

	ngOnInit()
	{
		this.loadShortTermRentals();
		this.filteredResults = this.shortTermRentals;
	}

	loadShortTermRentals()
	{
		this.reportService.propertySummaryList().pipe(first()).subscribe(

			data =>
			{
				this.shortTermRentals = data.data.propertySummaryList;
				this.filteredResults = this.shortTermRentals;
			},
			error =>
			{
				console.log('reports LIST!: ' + JSON.stringify(error));
				this.messageService.add({ severity: 'error', summary: 'error.message', life: 3000 });
			},
			() =>
			{ }
		);
	}



	/********
     * For each keystroke filter the list
     *
     */
	filter(event)
	{
		this.filteredResults = this.shortTermRentals.filter(str => str.propertyCode.toLowerCase().includes(event.query.toLowerCase()));
	}


	/********
     * When selection made, fire the notification event
     *
     */
	onSelect(shortTermRental: any)
	{
		this.shortTermRental = shortTermRental;
		this.doSelectShortTermRental.emit(this.shortTermRental);
	}


	/********
	 *
	 * See bug: https://github.com/primefaces/primeng/issues/2242
	 */
	public printOptions(shortTermRental: any)
	{
		return shortTermRental.propertyCode + ' : ' + shortTermRental.adrDevelopmentName;
	}
}
